import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  ValidateNested,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface KnowledgeUploadAttachmentResponse {
  results: any;
};


// 请求接口
export interface KnowledgeUploadAttachmentRequest {
  files: File;
  folderId: number;
  onProgress?: (progress: number) => void;
  signal?: AbortSignal;
}

class ResultsDetailData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Content title cannot be empty")
  @IsString("Content title must be a string")
  contentTitle: string;

  @Required("Item url cannot be empty")
  @IsString("Item url must be a string")
  itemUrl: string;

  @Required("Create time cannot be empty")
  @IsString("Create time must be a string")
  createTime: string
}

export class ResultsData {
  item: {
    itemType: string;
    id: number;
  }

  @ValidateNested(ResultsDetailData)
  detail: ResultsDetailData
}

export class KnowledgeUploadAttachmentData {
  @Required("Results cannot be empty")
  @IsArray("Results must be a ResultsData array")
  results: ResultsData[];
}

const transformAndValidateAgent = (
  response: KnowledgeUploadAttachmentResponse
): KnowledgeUploadAttachmentData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeUploadAttachmentData);
  } catch (error) {
    console.error("Knowledge Upload Attachment data validation failed:", error.message);
    throw error;
  }
};

/** 上传知识库附件 */
export const knowledgeUploadAttachment = async ({
  files,
  folderId,
  onProgress,
  signal,
}: KnowledgeUploadAttachmentRequest): Promise<KnowledgeUploadAttachmentData> => {
  const formData = new FormData()
  formData.append('folder_id', folderId.toString())
  formData.append('attachment', files)

  const response = await api.post<KnowledgeUploadAttachmentResponse>('/knowledge/upload_attachment', formData, {
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const loaded = (progressEvent.loaded * 100) / progressEvent.total;
        const progress = Math.round(loaded);
        onProgress(progress);
      }
    },
    timeout: 1000 * 60 * 5, // 5分钟超时
    signal,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
